import { useState, useEffect } from 'react';

const STORAGE_PREFIX = 'pengerno-';

const sameDocumentSetters = {};

export function useStickyState(keySuffix, initialValue = null) {
  const key = STORAGE_PREFIX + keySuffix;

  let internalValue, setInternalValue;

  if (process.browser) {
    let storedValue;

    try {
      storedValue = JSON.parse(window.localStorage.getItem(key));
    } catch (e) {
      //
    }

    [internalValue, setInternalValue] = useState(storedValue || initialValue);
  } else {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(
        'Using useStickyState() on the server side is not adviced.',
        'Falling back to initial value.'
      );
    }

    [internalValue, setInternalValue] = useState(initialValue);
  }

  useEffect(function() {
    if (!sameDocumentSetters.hasOwnProperty(key)) {
      sameDocumentSetters[key] = [];
    }

    sameDocumentSetters[key].push(setInternalValue);

    return () => {
      sameDocumentSetters[key] = sameDocumentSetters[key].filter(
        setter => setter !== setInternalValue
      );
    };
  }, []);

  useEffect(function autoSyncStickyStateValueViaLocalStorage() {
    function handleStorageEvent(event) {
      if (event.key === key && event.newValue !== internalValue) {
        setInternalValue(JSON.parse(event.newValue));
      }
    }

    window.addEventListener('storage', handleStorageEvent);

    return () => {
      window.removeEventListener('storage', handleStorageEvent);
    };
  }, []);

  function setValue(value) {
    sameDocumentSetters[key].forEach(setter => setter(value));

    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      //
    }
  }

  return [internalValue, setValue];
}
